import { I18nextContext } from 'gatsby-plugin-react-i18next';
import { useContext } from 'react';
import generateWatchProjectImage from "../../utils/generateWatchProjectImage";
import { dateFormatOptions } from '../../utils/i18n/format';
import ReferenceSearch from '../ReferenceSearch';

const TopSection = ({
  magazine,
  component,
}: { magazine: WatchProject21Api.Magazine, component: JSX.Element }) => {
  const { language } = useContext(I18nextContext);
  const date = new Date(magazine.createdAt).toLocaleDateString(language, dateFormatOptions)

  return (
    <div className="max-w-screen-2xl mx-auto mt-32 flex flex-col lg:flex-row">
      <div className="lg:w-1/3 lg:mr-32 lg:sticky top-16 self-start">
        <h1 className="font-cirka text-primary text-6xl mb-12">{magazine.heading || magazine.title}</h1>
        {/* <div>{magazine.brands && magazine.brands.map((brand) => brand.name)}</div> */}
        <h2 className="font-cirka text-xl mb-8" >{magazine.subTitle}</h2>
        <time className="text-gray-400 text-lg" dateTime={magazine.createdAt}>{date}</time>
      </div>
      <div className="lg:w-2/3">
        {component}
        <div className="flex mb-8">
          <img src={generateWatchProjectImage(magazine.topImage, magazine.title)} alt={magazine.topAltText} className="max-h-112" loading="lazy" />
        </div>
        {magazine.topText && (<div className="content content-formatted" dangerouslySetInnerHTML={{ __html: magazine.topText }} />)}
      </div>
    </div>
  )
}

const MiddleSection = ({ magazine }: { magazine: WatchProject21Api.Magazine }) => (
  <div className="max-w-screen-2xl mx-auto mt-32 flex flex-col lg:flex-row">
    <div className="lg:w-1/3 lg:mr-32 lg:sticky top-16 self-start">
      <img src={generateWatchProjectImage(magazine.middleImage, magazine.title)} alt={magazine.middleAltText} className="max-h-112" loading="lazy" />
    </div>
    <div className="lg:w-2/3">
      {magazine.middleText && (<div className="font-cirka text-5xl content" dangerouslySetInnerHTML={{ __html: magazine.middleText }} />)}
    </div>
  </div>
)

const BottomSection = ({ magazine }: { magazine: WatchProject21Api.Magazine }) => (
  <div className="max-w-screen-2xl mx-auto mt-32 flex flex-col lg:flex-row">
    <div className="lg:w-1/3 lg:mr-32" />
    <div className="lg:w-2/3">
      {magazine.bottomText && (<div className="content content-formatted" dangerouslySetInnerHTML={{ __html: magazine.bottomText }} />)}
      <div className="flex mt-8">
        <img src={generateWatchProjectImage(magazine.bottomImage, magazine.title)} alt={magazine.bottomAltText} className="max-h-112" loading="lazy" />
      </div>
    </div>
  </div>
)

const MagazineArticle = ({
  magazine,
  topComponent = <ReferenceSearch hasImage={false} />,
}: MagazineArticleProps) => (
  <article className="py-12 pt-16 px-7 bg-gray min-h-screen">
    {magazine.title && <TopSection magazine={magazine} component={topComponent} />}
    {magazine.middleText && <MiddleSection magazine={magazine} />}
    {magazine.bottomText && <BottomSection magazine={magazine} />}
  </article>
)

export default MagazineArticle;

type MagazineArticleProps = {
  magazine: WatchProject21Api.Magazine
  topComponent?: JSX.Element | null
}
